import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import type { UpdateUserRolesRequest } from '../../api/queries';

enum CacheKey {
  OrganizationUsers = 'OrganizationUsers',
}

export const useUpdateUserRolesMutation = () => {
  const { updateUserRoles } = useServicesContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, data }: { userId: number; data: UpdateUserRolesRequest }) =>
      updateUserRoles(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheKey.OrganizationUsers],
      });
    },
  });
};